import {Component, OnDestroy, OnInit} from '@angular/core';
import {ShoppingCartService} from '../../../services/shopping-cart.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-payson-confirmation',
  templateUrl: './payson-confirmation.component.html',
  styleUrls: ['./payson-confirmation.component.css']
})
export class PaysonConfirmationComponent implements OnInit,  OnDestroy {
  snippet: string;

  constructor(private cart: ShoppingCartService,
              private router: Router) { }

  ngOnInit() {
    this.snippet = this.cart.paysonSnippet;
  }
  ngOnDestroy() {
  this.cart.cleanUpShoppingCart();
  }

  toHome() {
    this.router.navigate(['']);
  }

}
